// extracted by mini-css-extract-plugin
export var expandIcon = "f0_ws";
export var rotated = "f0_wt";